/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Select, FlexRow, FlexCol } from 'sarsaparilla';
import { ANAN_ID, ANAN_COMPANY_LIST } from '../../constants';

export default class GuideDetails extends PureComponent {
    static propTypes = {
        handleIsGuidedChange: PropTypes.func,
        isCommerciallyGuided: PropTypes.bool,
        required: PropTypes.bool,
        guideDetails: PropTypes.object,
        guideValidations: PropTypes.object,
        permitId: PropTypes.string,
    };

    static defaultProps = {
        handleIsGuidedChange: () => {},
        required: false,
        guideDetails: {
            org_name: '',
        },
        guideValidations: {},
    };

    handleIsGuidedChecked = (e) => {
        this.props.handleIsGuidedChange(e.target.value === 'yes');
    };

    handleCompanySelect = (evt) => {
        const name = evt.target.value;
        this.props.handleIsGuidedChange(this.props.isCommerciallyGuided, {
            org_name: name,
        });
    };

    render() {
        const { isCommerciallyGuided, guideDetails, required, permitId } = this.props;

        const { org_name: orgName } = guideDetails;

        const { invalidOrgName } = this.props.guideValidations;

        const companyList = permitId === ANAN_ID ? ANAN_COMPANY_LIST : [];

        return (
            <div className="per-guide-form per-section-group">
                <div className="rec-order-detail-subsection-title">Commercial Guide</div>
                <legend id="commercial-guide-label">
                    Is this a commercially guided trip?
                    {required && (
                        <abbr className="rec-label-required-indicator" title="Required">
                            <span aria-hidden="true">*</span>
                            <span className="rec-sr-only">(Required)</span>
                        </abbr>
                    )}
                </legend>
                <div
                    className="rec-form-inline-item-wrap"
                    role="radiogroup"
                    aria-label="commercial-guide-label"
                >
                    <div className="rec-form-inline-item">
                        <label
                            htmlFor="commercial-guide-yes"
                            id="commercial-guide-label-yes"
                            className="rec-label-radio"
                        >
                            <input
                                type="radio"
                                className="rec-input-hide"
                                id="commercial-guide-yes"
                                name="commercial-guide-prompt"
                                checked={isCommerciallyGuided === true}
                                value="yes"
                                aria-label="commercial-guide-label-yes"
                                onChange={this.handleIsGuidedChecked}
                            />
                            <span className="rec-input-radio" />
                            Yes
                        </label>
                    </div>
                    <div className="rec-form-inline-item">
                        <label
                            htmlFor="commercial-guide-no"
                            id="commercial-guide-label-no"
                            className="rec-label-radio"
                        >
                            <input
                                type="radio"
                                className="rec-input-hide"
                                id="commercial-guide-no"
                                name="commercial-guide-prompt"
                                checked={isCommerciallyGuided === false}
                                value="no"
                                aria-label="commercial-guide-label-no"
                                onChange={this.handleIsGuidedChecked}
                            />
                            <span className="rec-input-radio" />
                            No
                        </label>
                    </div>
                </div>
                {isCommerciallyGuided && (
                    <FlexRow>
                        <FlexCol md={6}>
                            <div className="rec-form-item-wrap">
                                <Select
                                    label="Company Name"
                                    isRequired={!!required}
                                    id="guide-organization-name"
                                    options={companyList.map((item) => ({
                                        label: item,
                                        value: item,
                                    }))}
                                    onChange={this.handleCompanySelect}
                                    value={orgName}
                                    placeholder="Select an option..."
                                    isInvalid={invalidOrgName}
                                />
                            </div>
                        </FlexCol>
                    </FlexRow>
                )}
            </div>
        );
    }
}
